// extracted by mini-css-extract-plugin
export default {"header":"styles_header__P8FmO","info":"styles_info__36dlG","title":"styles_title__Okcdq","description":"styles_description__4oNPx"};